import useAsyncData from '../../hooks/useAsyncData/useAsyncData';
import { offers } from '../../api/client/adobe';
import { parseCookie } from '../../utilities/utils';

// @ts-expect-error TS2551: Property 'onLoadTarget' does not exist on type 'Window & typeof globalThis'. Did you mean 'onloadsta
const initialiser = parseCookie('mbox') ? undefined : window?.onLoadTarget;
const useHtmlOfferData = () => useAsyncData(offers, initialiser);

export default useHtmlOfferData;
